import React from 'react';

export default class Movie extends React.Component {

    constructor(props){
        super(props);

        this.state = {loaded:false};

        this.updateThings = this.updateThings.bind(this);


        this.updateThings(this.props.title)
    }


    updateThings(title) {
        this.props.database.getMovie(title).then((output) => {
            output["loaded"] = true;
            this.setState(output);
        });
    }


    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.title !== this.props.title){
            this.updateThings(nextProps.title);
            return false;
        }
        else{
            return true;
        }
    }


    render() {

        if(this.state.loaded){
            let width = (((this.state.overallScore  + 1) / 2) * 225);
            let image = "url(" + this.state.url + ")";
            return (
                <div style={{padding:"10px"}} className="col-xs-12 col-sm-4">
                    <div style={{overflow:"auto"}} className="movie">
                        <div>
                            <h1 className="movie-title">{this.props.title.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})}</h1>
                        </div>
                        <div className="col-xs-8 col-xs-offset-2" style={{marginBottom:"10px"}}>
                            <div style={{backgroundImage:image, backgroundPosition:"center", backgroundSize:"cover", width:"100%", paddingTop:"150%"}}/>
                        </div>
                        <div className="col-xs-12">
                            <div style={{width:"225px", margin:"0 auto"}}>
                                <div className="stars" style={{width:width, height:"45px", overflow:"hidden"}}>
                                    <div style={{width:"225px", margin:"0 auto"}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0,0,260,245" width="45" height="45">
                                            <path fill="#FFDF00" d="m55,237 74-228 74,228L9,96h240"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0,0,260,245" width="45" height="45">
                                            <path fill="#FFDF00" d="m55,237 74-228 74,228L9,96h240"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0,0,260,245" width="45" height="45">
                                            <path fill="#FFDF00" d="m55,237 74-228 74,228L9,96h240"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0,0,260,245" width="45" height="45">
                                            <path fill="#FFDF00" d="m55,237 74-228 74,228L9,96h240"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0,0,260,245" width="45" height="45">
                                            <path fill="#FFDF00" d="m55,237 74-228 74,228L9,96h240"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <h3>Overall Sentiment: <span style={{whiteSpace: "nowrap"}}>{Math.floor((this.state.overallScore + 1) * 50)}% Positive</span></h3>
                        </div>
                        <div className="col-xs-12">
                            <Review title="Popular Review" source={this.state.popularEx.source} user={this.state.popularEx.author} text={this.state.popularEx.text} />
                        </div>
                        <div className="col-xs-12">
                            <Review title="Positive Review" source={this.state.positiveEx.source} user={this.state.positiveEx.author} text={this.state.positiveEx.text} />
                        </div>
                        <div className="col-xs-12">
                            <Review title="Negative Review" source={this.state.negativeEx.source} user={this.state.negativeEx.author} text={this.state.negativeEx.text} />
                        </div>
                    </div>
                </div>
            );
        }
        else{
            return(
                <div className="col-xs-12 movie">
                    LOADING...
                </div>
            )
        }

    }
}



class Review extends React.Component {
    render(){
        return(
            <div className="col-xs-12">
                <h4 className="center">{this.props.title}</h4>
                <p style={{textAlign:"left"}}>"{this.props.text}"</p>
                <p style={{textAlign:"right"}}>-{this.props.user} via {this.props.source}</p>
            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/movie.jsx